<div class="custom-snackbar d-flex justify-content-between align-items-center">
  <div>
    <span class="text-dark">It looks like you've navigated away from the quiz.<br>Please focus on the quiz to avoid any penalties.</span>
  </div>
  <button mat-icon-button (click)="dismissSnackbar()" class="d-inline-flex">
    <mat-icon class="fs-5 text-secondary">close</mat-icon>
  </button>
</div>
